<div class="ch-panel-content-wrapper">
  <div class="ch-tabs-wrapper">
    <div class="ch-tabs" *ngIf="_conversation !== undefined">
      <div
        [ngClass]="{ active: activeTab == 'open' }"
        (click)="switchTabs('open')"
      >
        Open
        <div
          class="client-task-pill"
          title="Open client tasks"
          *ngIf="_conversation.open_tasks_count != null"
        >
          {{ _conversation.answered_tasks_count }} /
          {{ _conversation.open_tasks_count }}
        </div>
      </div>
      <div
        [ngClass]="{ active: activeTab == 'all' }"
        (click)="switchTabs('all')"
      >
        Closed
      </div>
      <div class="text-right btn-reminder-wrapper">
        <button
          *ngIf="
            (countOpenTrackedItems(_conversation.tracked_items) > 0 ||
              qboTrackedItemsCounts().unanswered_count > 0 ||
              xeroTrackedItemsCounts.unanswered_count > 0) &&
            data.user_type == 1
          "
          class="btn btn-link"
          style="float: right; margin-top: -12px; margin-right: -20px"
          (click)="sendReminder(_conversation.uuid)"
          container="body"
          [tooltip]="
            lastReminderSentDate()
              ? 'Last reminder sent: ' +
                (lastReminderSentDate()
                  | amFromUtc
                  | amLocal
                  | amDateFormat: 'MMM, Do YYYY, h:mm A')
              : null
          "
        >
          Remind all
        </button>
      </div>
    </div>
  </div>

  <!-- <div class="date-separator"><div class="date">Today</div></div> -->
  <div
    class="ch-panel-content-scrollable-wrapper"
    [ngClass]="{ 'component-loading': loading }"
    *ngIf="_conversation !== undefined"
  >
    <div class="ch-panel-content-scrollable" style="padding-bottom: 15px">
      <div
        class="qbo-cards"
        style="margin-top: 10px"
        (click)="openQBOPanel()"
        *ngIf="activeTab == 'open' && isQboConnected"
      >
        <h4>QuickBooks Items</h4>
        <div class="d-flex aligm-items-center">
          <div class="left">
            <div class="qbo-quantity color-red">
              {{ qboTrackedItemsCounts().unanswered_count }}
            </div>
            <div class="qbo-label">Not answered</div>
          </div>
          <div class="right" *ngIf="data.user_type == 1">
            <div class="qbo-quantity color-orange">
              {{ qboTrackedItemsCounts().to_review_count }}
            </div>
            <div class="qbo-label">Waiting review</div>
          </div>
        </div>
      </div>

      <div
        class="xero-cards"
        style="margin-top: 10px"
        (click)="openXeroPanel()"
        *ngIf="activeTab == 'open' && isXeroConnected"
      >
        <h4>Xero Items</h4>
        <div class="d-flex aligm-items-center">
          <div class="left">
            <div class="xero-quantity color-red">
              {{ xeroTrackedItemsCounts.unanswered_count }}
            </div>
            <div class="xero-label">Not answered</div>
          </div>
          <div class="right" *ngIf="data.user_type == 1">
            <div class="xero-quantity color-orange">
              {{ xeroTrackedItemsCounts.to_review_count }}
            </div>
            <div class="xero-label">Waiting review</div>
          </div>
        </div>
      </div>
      <div
        class="no-open-tracked-items"
        *ngIf="
          (activeTab == 'open' &&
            countOpenTrackedItems(_conversation.tracked_items) == 0 &&
            loading == false) ||
          (activeTab == 'all' &&
            _conversation.tracked_items.length == 0 &&
            loading == false)
        "
      >
        <!-- <img class="emoji" src="assets/img/happiness.svg"> -->
        <div class="emoji" style="margin-bottom: 0">
          <svg
            width="142"
            height="77"
            viewBox="0 0 142 77"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g filter="url(#filter0_d)">
              <rect x="2" y="10" width="138" height="63" rx="8" fill="white" />
              <rect
                x="2.5"
                y="10.5"
                width="137"
                height="62"
                rx="7.5"
                stroke="#EBEDF0"
              />
            </g>
            <rect
              x="99"
              y="20"
              width="32"
              height="14.0432"
              rx="7.02161"
              fill="#D7FFD9"
            />
            <rect
              opacity="0.3"
              x="11"
              y="22.0432"
              width="48"
              height="10"
              rx="5"
              fill="#151C29"
            />
            <rect
              opacity="0.3"
              x="11"
              y="37.0432"
              width="56"
              height="10"
              rx="5"
              fill="#485364"
            />
            <rect
              opacity="0.3"
              x="11"
              y="52.0432"
              width="28"
              height="10"
              rx="5"
              fill="#0075FF"
            />
            <path
              opacity="0.8"
              d="M90.4649 24.2843L92.1017 28.7221C92.1632 28.8892 92.3223 29 92.5001 29C92.678 29 92.837 28.8892 92.8986 28.7221L94.5353 24.2843C95.8602 20.6916 98.6922 17.8596 102.285 16.5349L106.722 14.8982C106.889 14.8367 107 14.6776 107 14.4997C107 14.3219 106.889 14.1628 106.722 14.1013L102.284 12.4646C98.692 11.1397 95.8599 8.30787 94.5353 4.71544L92.8986 0.277629C92.837 0.110802 92.678 0 92.5001 0C92.3223 0 92.1632 0.110802 92.1017 0.277629L90.4649 4.71544C89.1401 8.30787 86.3083 11.1397 82.7157 12.4646L78.2776 14.1013C78.1108 14.1628 78 14.3219 78 14.4997C78 14.6776 78.1108 14.8367 78.2776 14.8982L82.7154 16.5349C86.308 17.8596 89.1401 20.6914 90.4649 24.2843Z"
              fill="#0075FF"
            />
            <path
              opacity="0.6"
              d="M41.8998 73.3385L43.0684 76.507C43.1123 76.6263 43.2259 76.7054 43.3529 76.7054C43.4799 76.7054 43.5934 76.6263 43.6374 76.507L44.806 73.3385C45.7519 70.7734 47.7739 68.7514 50.3389 67.8056L53.5074 66.637C53.6265 66.5931 53.7056 66.4795 53.7056 66.3525C53.7056 66.2256 53.6265 66.112 53.5074 66.068L50.3387 64.8994C47.7738 63.9535 45.7517 61.9316 44.806 59.3667L43.6374 56.1982C43.5934 56.0791 43.4799 56 43.3529 56C43.2259 56 43.1123 56.0791 43.0684 56.1982L41.8998 59.3667C40.9539 61.9316 38.932 63.9535 36.3669 64.8994L33.1982 66.068C33.0791 66.112 33 66.2256 33 66.3525C33 66.4795 33.0791 66.5931 33.1982 66.637L36.3667 67.8056C38.9318 68.7514 40.9539 70.7732 41.8998 73.3385Z"
              fill="#0075FF"
            />
            <path
              opacity="0.3"
              d="M121.728 75.2113L122.349 76.8946C122.372 76.958 122.433 77 122.5 77C122.568 77 122.628 76.958 122.651 76.8946L123.272 75.2113C123.775 73.8485 124.849 72.7743 126.211 72.2719L127.895 71.651C127.958 71.6277 128 71.5674 128 71.4999C128 71.4325 127.958 71.3721 127.895 71.3488L126.211 70.7279C124.849 70.2254 123.774 69.1513 123.272 67.7886L122.651 66.1053C122.628 66.042 122.568 66 122.5 66C122.433 66 122.372 66.042 122.349 66.1053L121.728 67.7886C121.226 69.1513 120.151 70.2254 118.789 70.7279L117.105 71.3488C117.042 71.3721 117 71.4325 117 71.4999C117 71.5674 117.042 71.6277 117.105 71.651L118.789 72.2719C120.151 72.7743 121.226 73.8485 121.728 75.2113Z"
              fill="#0075FF"
            />
            <defs>
              <filter
                id="filter0_d"
                x="0"
                y="9"
                width="142"
                height="67"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
              >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                  in="SourceAlpha"
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="1" />
                <feColorMatrix
                  type="matrix"
                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                  mode="normal"
                  in2="BackgroundImageFix"
                  result="effect1_dropShadow"
                />
                <feBlend
                  mode="normal"
                  in="SourceGraphic"
                  in2="effect1_dropShadow"
                  result="shape"
                />
              </filter>
            </defs>
          </svg>
        </div>
        <h4>Yay!</h4>
        <p>There are no open client tasks.</p>
      </div>

      <div
        *ngFor="
          let tracked_item of _conversation.tracked_items;
          trackBy: trackById
        "
      >
        <tracked-item-bubble
          id="bubble-{{ tracked_item.id }}"
          #bubble
          *ngIf="
            tracked_item.created_by !== null &&
            ((tracked_item.type != 6 && tracked_item.type != 7) ||
              (!showOpenTrackedItems && tracked_item.satisfied == true))
          "
          [tracked_item]="tracked_item"
          [user]="user"
          [company]="_company"
          [conversation]="_conversation"
          [accounts]="accounts"
          [classes]="classes"
          [shouldOpenDrawer]="true"
          [hasSelectableClass]="hasSelectableClass"
          [workspaceCard]="true"
          class="workspace-client-task-card"
        >
        </tracked-item-bubble>
      </div>
      <div
        style="display: flex; justify-content: center; margin-top: 10px"
        *ngIf="
          _conversation.tracked_items.length % 25 == 0 &&
          _conversation.tracked_items.length > 0
        "
      >
        <button class="btn btn-primary-light" (click)="loadMore()">
          Load More
        </button>
      </div>
    </div>
  </div>
  <button
    *ngIf="data.user_type == 1"
    style="height: 44px"
    [disabled]="active_conversation.company.archived"
    (click)="openModal('new-tracked-items')"
    class="btn btn-primary btn-lg btn-block"
  >
    <i class="feather check-circle"></i> New Client Tasks
  </button>
</div>
